import { render, staticRenderFns } from "./integralExchanges.vue?vue&type=template&id=598ec51a&"
import script from "./integralExchanges.vue?vue&type=script&lang=js&"
export * from "./integralExchanges.vue?vue&type=script&lang=js&"
import style0 from "./integralExchanges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports